import { fetchAPI } from "./utils";
import { MessageResponse } from "../types/types";
import {
    CreateRagFolderParams,
    DeleteRagFolderParams,
    GetRagFolderFilesParams,
    ReorderRagFoldersParams,
    UpdateRagFolderParams,
} from "../types/requestInputs";
import { GetRagFolderFilesResponse, GetRagFoldersResponse } from "../types/requestsOutputs";

// Create a new RAG folder
export const createRagFolder = async ({ token, name }: CreateRagFolderParams): Promise<{ id: string }> => {
    return fetchAPI<{ id: string }>("/create-rag-folder", "POST", { name }, token);
};

// Get all RAG folders for the admin's company
export const getRagFolders = async ({ token }: { token: string }): Promise<GetRagFoldersResponse> => {
    return fetchAPI<GetRagFoldersResponse>("/get-rag-folders", "POST", undefined, token);
};

// Update a RAG folder name
export const updateRagFolder = async ({
    token,
    folderId,
    newName,
}: UpdateRagFolderParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/update-rag-folder", "POST", { folderId, newName }, token);
};

// Delete a RAG folder
export const deleteRagFolder = async ({ token, folderId }: DeleteRagFolderParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/delete-rag-folder", "POST", { folderId }, token);
};

// Reorder RAG folders. `orderedFolderIds` represents the desired order (index 0 = top).
export const reorderRagFolders = async ({
    token,
    orderedFolderIds,
}: ReorderRagFoldersParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/reorder-rag-folders", "POST", { orderedFolderIds }, token);
};

// Get all files available both in DB and Vector store for a specific RAG folder
export const getRagFolderFiles = async ({
    token,
    folderId,
}: GetRagFolderFilesParams): Promise<GetRagFolderFilesResponse> => {
    return fetchAPI<GetRagFolderFilesResponse>("/get-rag-folder-files", "POST", { folderId }, token);
};
